/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import '@/payment-services/components/CreditCardForm/CreditCardError.css';
import { Icon } from '@adobe-commerce/elsie/components';
import { Warning } from '@adobe-commerce/elsie/icons';
import { FunctionalComponent } from 'preact';

export interface CreditCardErrorProps {
  message: string;
}

export const CreditCardError: FunctionalComponent<CreditCardErrorProps> = ({
  message,
}) => {
  return (
    <div className="credit-card-error">
      <Icon
        source={Warning}
        alt="Warning"
        className="credit-card-error__icon"
        data-testid="credit-card-error-icon"
      />
      <p className="credit-card-error__message">{message}</p>
    </div>
  );
};
